class AccountSettings.InstagramListeningHashtagCreatorView extends Backbone.View

  template: JST["backbone/templates/account_settings/topics/instagram_listening_hashtag_creator"]

  events:
    'click #new-hashtag': 'onClickAdNewHashtag'
    'click #save-new-hashtag': 'onClickSaveNewHashtag'
    'blur #hashtag_name' : 'onBlurHashtagName'
    'input #hashtag_name' : 'onInputHashtagName'
    'hidden.bs.modal #new-hashtag-modal' : 'onModalClose'

  initialize:(source)->
    @source = source

  render: ->
    @$el.html(@template())
    @listeningEndpointView = new AccountSettings.InstagramListeningEndpointsView()
    @$('#listening-endpoint-container').append(@listeningEndpointView.render().el)
    @$el.find('#error_validation').text('')
    _.each(@$el.find('select'), (select) =>
      $(select).chosen(width: "220px", disable_search: true)
    )
    @

  onModalClose:(event) ->
    @$el.find('#hashtag_name').val('')

  onClickAdNewHashtag:(event)->
    event.preventDefault()
    @$el.find('#new-hashtag-modal').modal('show');

  onInputHashtagName: (event)->
    @$el.find('#error_validation').text('')


  onBlurHashtagName: (event)->
    name = @$el.find('#hashtag_name').val()
    errorMessage = ''
    if(name == '')||(name == null)
      errorMessage = 'Required field'
    else
      if(name.indexOf(' ') != -1)
        errorMessage = 'Hashtag should not have spaces'
    @$el.find('#error_validation').text(errorMessage)


  onClickSaveNewHashtag:(event)->
    event.preventDefault()

    hashtag_name = @$el.find('#hashtag_name').val()
    loading_button = @$el.find('#saving-hashtag')
    renovation_type = @$el.find('.renovation_type').val()
    source_id = @$el.find('#source_id').val()
    hashtag_data = {
      hashtag_name: hashtag_name,
      renovation_type: renovation_type,
      source_id: @source,
      endpoint_selected: @listeningEndpointView.getEndpointSelected()
    }
    $(event.target).hide()
    $(loading_button).show()
    @doSave(hashtag_data, event.target, loading_button)

  doSave: (hashtag_data, save_btn, loader)->
    $.ajax
      url: '/keepcon/hashtag_searches/create_hashtag_search',
      type: 'POST',
      dataType: 'json',
      data: hashtag_data
      success: (response) =>
        if(response.success)
          @$el.find('#new-hashtag-modal').modal('hide');
          @trigger('hashtag:added:one', response.hashtag)
        else
          @$el.find('#error_validation').text(response.error_message)
        $(loader).hide()
        $(save_btn).show()
